import { EditorStateAsHtml, Typography } from '@repo/ui';
import useGetPartnerNote from 'hooks/partnerNotes/useGetPartnerNote';
import { Navigate, useParams } from 'react-router-dom';
import useFeature from 'services/features/useFeature';
import styles from './PartnerRecs.module.css';

export default function PartnerRecs() {
  const { isFeatureEnabled } = useFeature('partner_recommendation_note');
  const { partnerId } = useParams<{ partnerId: string }>();
  const partnerNote = useGetPartnerNote(partnerId);

  if (!isFeatureEnabled || !partnerNote) return <Navigate to='/' replace />;

  return (
    <main className={styles.pageContainer}>
      <div className={styles.partnerRecsContainer}>
        <Typography variant='heading-xl'>
          {partnerNote?.partner?.name ?? 'Partner'} Plan
        </Typography>
        <EditorStateAsHtml
          getEditorStateFnOrKey={() => partnerNote?.partnerNote.content ?? null}
          deps={[partnerNote?.partnerNote.content]}
        />
      </div>
    </main>
  );
}
